import {resources} from "../../../../../../../core/models/resource/resources";

export const competitorArticlesResourceType = resources['competitor-articles'];
